import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IDriverAuth } from "src/@types/driver-auth";

interface DriverLoginResponse {
  accessToken: string;
  driver: {
    id: string;
    name: string;
    phone: string;
  };
}

interface DriverCodeResponse {
  success: boolean;
}

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

export const postDriverSendCode: any = createAsyncThunk<
  DriverCodeResponse,
  { ownerId: string; phone: string }
>("driverAuth/postDriverSendCode", async ({ ownerId, phone }, thunkAPI) => {
  try {
    const response = await api.post("/delivery/driver/login/phone", {
      ownerId,
      phone,
    });
    return response.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Erro ao solicitar código.";
    return thunkAPI.rejectWithValue(message);
  }
});

export const postDriverVerifyCode: any = createAsyncThunk<
  DriverLoginResponse,
  { ownerId: string; phone: string; code: string }
>("driverAuth/postDriverVerifyCode", async ({ ownerId, phone, code }, thunkAPI) => {
  try {
    const response = await api.post("/delivery/driver/login/verify", {
      ownerId,
      phone,
      code,
    });
    return response.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Código inválido ou expirado.";
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState: IDriverAuth = {
  accessToken: "",
  driver: {
    id: "",
    name: "",
    phone: "",
  },
  isLoading: false,
  error: null,
};

const driverAuthSlice = createSlice({
  name: "driverAuth",
  initialState,
  reducers: {
    driverLogout: (state) => {
      state.accessToken = "";
      state.driver = { ...initialState.driver };
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postDriverSendCode.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(postDriverSendCode.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(postDriverSendCode.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          (action.payload as string) ||
          action.error?.message ||
          "Erro ao solicitar código.";
      })
      .addCase(postDriverVerifyCode.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(postDriverVerifyCode.fulfilled, (state, action) => {
        state.isLoading = false;
        state.accessToken = action.payload.accessToken;
        state.driver = {
          id: action.payload.driver.id,
          name: action.payload.driver.name,
          phone: action.payload.driver.phone,
        };
        state.error = null;
      })
      .addCase(postDriverVerifyCode.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          (action.payload as string) ||
          action.error?.message ||
          "Código inválido ou expirado.";
      });
  },
});

export const { driverLogout } = driverAuthSlice.actions;

export default driverAuthSlice.reducer;
